<template>
  <div class="component-wrapper">
    <button @click.prevent="addCodes">Add Codes (If you see this, tell Michelle -- Do NOT Click)</button>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')

export default {
  data() {
    return {
      accessCodes: []
    }
  },
  methods: {
    addCodes() {
      this.accessCodes.forEach((code) => {
        fb.districtCodesCollection.doc(code.accessCode).set({
          status: code.status
        }).then(() => {
          console.log('Codes added!')
        }).catch((err) => {
          console.log(err)
        })
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
